export default __webpack_public_path__ + "static/media/KfsysccLogo_4.5e4f21f3.svg";